import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import audience from "../../../images/Target-Audience.png";
import { ImageTextPair } from "../../../components/image-text-pair";

export interface IRecapProps {
    sectionId: string;
    index: number;
}

export function Recap(props: IRecapProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Recap`}
            />
            <ImageTextPair
                imgSrc={audience}
                title="Who we're designing for"
                body= "We sought to create human-AI collaborative interventions for users who unintentionally spread and consume misinformation on social platforms. Since they make up the largest sector of social platform users, if we can help them build better engagement habits, we can make a big difference in reducing the spread of misinformation overall."
            />
        </Section>
    );
}
